<template>
  <div class="my-collection-area" :class="{ 'my-collection-area-mobile': isMobile, background_white: isMobile && module === 'orderRec' }">
    <invoice-list ref="invoiceListRef" v-if="showInvoiceList" />
    <invoice-history-list v-else-if="showInvoiceHistory" />
    <div v-else>
      <div class="head" :class="{ large_margin: showSearch }">
        <div class="left-top" @click="showSelect = !showSelect" v-if="isMobile">
          <img v-if="module === 'collect'" :src="showSelect ? require('@imgs/personalPage/check-icon1.png') : require('@imgs/personalPage/check-icon.png')" alt="" class="input_icon input_sear" />
          <img v-if="module === 'orderRec'" src="@imgs/back_mobile.png" @click="goBack()" alt="" class="input_icon input_sear" />
        </div>
        <div class="title">{{ title }}</div>
        <div class="right-top" v-if="!isMobile">
          <div class="invoice-wrapper" v-if="module == 'order'">
            <span class="main-text" @click="openInvoiceList">开发票</span>
            <span class="main-text" @click="showInvoiceHistory = true">查看开票记录</span>
          </div>
          <div class="select" v-if="module === 'collect'" v-show="!showSelect" @click="showSelect = true">多选</div>
          <el-checkbox v-if="module === 'collect'" v-model="selectAllVal" v-show="showSelect" class="right-item" @change="selectAll">全选</el-checkbox>
          <div v-if="module === 'collect'" v-show="showSelect" @click="showCancel()" class="cancel-select right-item">批量取消收藏</div>
          <el-input class="right-item search-input" v-model="queryName" placeholder="输入作品名称" size="mini" prefix-icon="el-icon-search" :maxlength="500">
            <template slot="append"><a @click="getWorkList">搜索</a></template>
          </el-input>
          <div class="head-button right right-item reset" @click="reset()">
            重置
          </div>
        </div>
        <div class="right-top" v-else>
          <el-popover trigger="click" width="110" v-if="module === 'orderRec'" v-model="visible">
            <img slot="reference" src="@imgs/personalPage/invoice@2x.png" alt="" class="mr-5 input_icon input_sear" />
            <div class="mobile-invoice-popover">
              <p @click="openMobileInvoiceList('list')">开发票</p>
              <p @click="openMobileInvoiceList('record')">查看开票记录</p>
            </div>
          </el-popover>
          <img src="@imgs/personalPage/search-icon.png" alt="" class="input_icon input_sear" @click="showSearchBox" />
          <el-input class="right-item search-input" v-show="showSearch" v-model="queryName" placeholder="输入作品名称" size="mini" prefix-icon="el-icon-search" :maxlength="500">
            <template slot="append"><a @click="getWorkList">搜索</a></template>
          </el-input>
        </div>
      </div>
      <div class="book-list" :class="module">
        <list-frame :totalCount="totalCount" :show-foot="!isMobile" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="!isMobile ? 12 : 99999">
          <template v-slot:listContent>
            <div class="collect-item" :class="{ large: module === 'orderRec' }" v-for="item in workList" v-bind:key="item.id">
              <div class="cover" @click="read(item)">
                <img v-if="item.cover" :src="item.cover" />
                <img class="default" v-else src="@imgs/personalPage/book-cover.png" alt="" />
              </div>
              <el-checkbox v-show="showSelect" v-if="module === 'collect'" class="item-checkbox" v-model="item.select" @change="selectWork($event, item.id)"></el-checkbox>
              <div v-if="!isMobile || module === 'orderRec'" class="info-and-deal">
                <p class="title">{{ item.worksName }}</p>
                <p v-if="module === 'orderRec'">订单号：{{ item.orderCode }}</p>
                <p>{{ module === 'collect' ? '收藏日期：' + item.date : '订阅日期：' + item.date }}</p>
                <p v-if="module === 'orderRec'">订阅截止日期：{{ item.endTime }}</p>
                <el-button v-if="module === 'collect'" class="cancel-collect" @click="showCancel(item.id)">取消收藏</el-button>
              </div>
              <div v-else class="info-and-deal ll">
                <p>{{ item.worksName }}</p>
              </div>
            </div>
          </template>
        </list-frame>
      </div>
      <div class="right-bottom" v-show="showSelect" v-if="isMobile && module === 'collect'">
        <el-checkbox class="right-item" @change="selectAll">全选</el-checkbox>
        <div @click="showCancel()" class="cancel-select right-item"><img src="@imgs/personalPage/cancel-icon.png" />取消收藏</div>
      </div>
      <tip-dialog ref="collectDialog" :dialogOptions="dialogOptions" @clickCancel="cancelSelect" @clickConfirm="cancelCollect"></tip-dialog>
    </div>
  </div>
</template>

<script>
import ListFrame from '../../list/listFrame'
import invoiceList from '../../personalPage/components/InvoiceList'
import invoiceHistoryList from '@components/personalPage/components/InvoiceHistoryList'
import moment from 'moment'
import homeApi from '@api/home'
import TipDialog from '@components/common/TipDialog'
export default {
  name: 'MyCollectionOrder',
  components: { TipDialog, ListFrame, invoiceList, invoiceHistoryList },
  data() {
    return {
      currentPageNo: 1,
      totalCount: 0,
      workList: [],
      queryName: '',
      cancelIds: [],
      cancelId: '',
      showSelect: false,
      showSearch: false,
      selectAllVal: false,
      dialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否取消收藏，取消后将无法找回？'
      },
      showInvoiceList: false,
      showInvoiceHistory: false,
      visible: false
    }
  },
  props: {
    module: {
      type: String
    },
    title: {
      type: String
    }
  },
  created() {
    this.getWorkList()
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  methods: {
    getWorkList() {
      let queryApi = homeApi[this.module + 'ByPage']
      let param = {
        pageNo: this.currentPageNo,
        pageSize: !this.isMobile ? 12 : 99999,
        worksName: this.queryName
      }
      queryApi(param).then((res) => {
        if (res.data.data.page) {
          this.totalCount = res.data.data.page.totalCount
          this.workList = res.data.data.page.result.map((item) => {
            return {
              ...item,
              date: moment(item.createTime).format('YYYY-MM-DD'),
              endTime: item.endTime === 0 ? '永久' : moment(item.endTime).format('YYYY-MM-DD')
            }
          })
        } else {
          this.$message({
            message: '接口请求失败',
            type: 'error'
          })
        }
      })
    },
    flipPage(val) {
      this.currentPageNo = val
      this.getWorkList()
    },
    read(item) {
      let url = ''
      if (item.worksType === 'cloud_read_ebook') {
        let routeUrl = this.$router.resolve({
          path: '/content',
          query: { id: item.worksId }
        })
        url = routeUrl.href
      } else if (item.worksType === 'cloud_read_album') {
        this.$store.commit('config/UPDATE_BOOK_ID', item.id)
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
        let routeUrl = this.$router.resolve({
          path: '/bookshelfdetail',
          query: { id: item.worksId, openMode: item.openMode }
        })
        url = routeUrl.href
      } else if (item.worksType === 'cloud_read_lib') {
        this.$store.commit('config/UPDATE_BOOK_ID', item.id)
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
        let routeUrl = this.$router.resolve({
          path: '/booklibdetail',
          query: { id: item.worksId, openMode: item.openMode }
        })
        url = routeUrl.href
      } else if (item.worksType === 'cloud_read_article' || item.worksType === 'cloud_read_ebook_article') {
        let path = '/digitalArticle'
        let routeUrl = this.$router.resolve({
          path: path,
          query: { id: item.worksId, from: 'personal' }
        })
        url = routeUrl.href
      } else if (item.worksType === 'cloud_read_epaper') {
        url = window.location.origin + '/ebook/epaper/index.jhtml?id=' + item.worksId
      } else if (item.worksType.indexOf('cloud_read_baozhi') > -1) {
        if (item.epaperId) {
          let routeUrl = this.$router.resolve({
            path: '/paperContent',
            query: { id: item.epaperId }
          })
          url = routeUrl.href
        } else url = window.location.origin + '/ebook/baozhi/index.jhtml?id=' + item.worksId
      }
      window.open(url, '_blank')
    },
    selectWork(val, item) {
      if (val) {
        this.cancelIds.push(item)
      } else {
        this.cancelIds.splice(this.cancelIds.indexOf(item), 1)
      }
    },
    selectAll(val) {
      for (const i in this.workList) {
        this.$set(this.workList[i], 'select', val)
        if (val) {
          this.cancelIds.push(this.workList[i].id)
        }
      }
      if (!val) {
        this.cancelIds = []
      }
    },
    showCancel(id) {
      this.$refs.collectDialog.visible = true
      if (id) {
        this.cancelId = id
      }
    },
    cancelCollect() {
      homeApi.cancelCollect({ ids: this.cancelId ? this.cancelId : this.cancelIds.join() }).then((res) => {
        if (res.data.status === 0) {
          this.getWorkList()
          this.cancelIds = []
          this.showSelect = false
          this.selectAllVal = false
        }
      })
      this.cancelId = ''
    },
    cancelSelect() {
      this.cancelId = ''
      this.selectAll(false)
      this.showSelect = false
      this.selectAllVal = false
    },
    goBack() {
      this.$emit('goBack', 'info')
    },
    showSearchBox() {
      this.showSearch = !this.showSearch
      if (!this.showSearch) {
        this.reset()
      }
    },
    reset() {
      this.queryName = ''
      this.currentPageNo = 1
      this.getWorkList()
    },
    openInvoiceList() {
      this.showInvoiceList = true
    },
    openMobileInvoiceList(type) {
      this.$parent.currentModule = 'invoice'
      this.$parent.invoiceListTitle = type
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.my-collection-area {
  width: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #515151;
    }
    .right-top {
      display: flex;
      font-size: 14px;
      color: #515151;
      align-items: center;
      .mr-5 {
        margin-top: 5px;
        margin-right: 5px;
      }
      .invoice-wrapper {
        display: inline-flex;
        column-gap: 20px;
        margin-right: 20px;
      }
      .select {
        margin-right: 20px;
        color: #df5813;
        cursor: pointer;
      }
      .right-item {
        margin-right: 20px;
        cursor: pointer;
        &.reset {
          margin-right: 30px;
        }
      }
      .head-button {
        width: 60px;
        height: 28px;
        border-radius: 5px;
        color: #fff;
        font-size: 12px;
        line-height: 28px;
        vertical-align: center;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        cursor: pointer;
        background-color: #999999;
      }
    }
  }
  .book-list {
    .collect-item {
      width: 230px;
      height: 360px;
      border: 1px solid #e8e8e8;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      vertical-align: top;
      .cover {
        vertical-align: middle;
        text-align: center;
        height: 270px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          vertical-align: middle;
          margin: 0 auto;
          width: 100%;
          height: 100%;
        }
        img.default {
          width: 128px;
        }
      }
      .info-and-deal {
        background: #999999;
        color: #fff;
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 6px 10px;
        p {
          font-size: 14px;
          margin: 0;
          line-height: 18px;
          overflow: hidden;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }
        .el-button {
          background-color: unset;
          border-radius: 12px;
          border: #ffffff solid 1px;
          width: 80px;
          height: 24px;
          color: #fff;
          padding: 0;
          font-size: 12px;
        }
      }
      .item-checkbox {
        position: absolute;
        bottom: 90px;
        right: 10px;
      }
      &.large {
        display: inline-flex;
        width: 300px;
        height: 100px;
        border: none;
        .cover {
          width: 75px;
          height: 100px;
        }
        .info-and-deal {
          height: 100%;
          background-color: #fff;
          color: #515151;
          font-size: 12px;
          .title {
            font-size: 14px;
            color: #000000;
            font-weight: 600;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
.my-collection-area-mobile {
  background: #f5f5f5;
  width: 100%;
  height: calc(100vh - 74px);
  .head {
    justify-content: center;
    height: 55px;
    border-bottom: #eaeaea 1px solid;
    position: relative;
    width: calc(100% - 40px);
    margin-left: 20px;
    .title {
      line-height: 55px;
    }
    .right-top {
      position: absolute;
      right: 20px;
      top: 15px;
      img {
        width: 26px;
      }
      .search-input {
        position: fixed;
        width: 300px;
        top: 60px;
        right: 0;
      }
    }
    .left-top {
      position: absolute;
      left: 20px;
      top: 15px;
      img {
        width: 26px;
      }
    }
    &.large_margin {
      margin-bottom: 30px;
    }
  }
  .book-list {
    padding-left: 10px;
    width: 340px;
    margin: 0 auto;
    overflow-x: hidden;
    .collect-item {
      width: 100px;
      height: 185px;
      .cover {
        height: 134px;
        img {
          max-width: 100px;
          max-height: 134px;
        }
      }
      .info-and-deal {
        height: 50px;
      }
      &.large {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 120px;
        border: none;
        .cover {
          height: 120px;
          width: 90px;
          img {
            max-width: 90px;
            max-height: 120px;
          }
        }
        .info-and-deal {
          width: calc(100% - 100px);
          padding-left: 15px;
          padding-right: 0;
          background-color: #fff;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: #515151;
          &.title {
            font-weight: 600;
            color: #000000;
            margin-bottom: 15px !important;
          }
        }
      }
      .item-checkbox {
        bottom: 50px;
        right: 5px;
      }
    }
  }
  .right-bottom {
    font-size: 14px;
    text-align: center;
    position: fixed;
    bottom: 76px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    .cancel-select {
      display: inline-block;
      margin-left: 20px;
      img {
        width: 16px;
        vertical-align: middle;
      }
    }
  }
}
.mobile-invoice-popover {
  padding: 5px;
  p {
    margin: 0;
    height: 40px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    color: #3a3a3a;
    line-height: 40px;
  }
  p:first-child {
    border-bottom: 1px solid #eaeaea;
  }
}
.background_white {
  background-color: #fff;
}
</style>
<style lang="scss">
.my-collection-area {
  .search-input {
    width: 200px;
    height: 24px;
    .el-input-group__append {
      background-color: #df5813;
      border-color: #df5813;
      color: #ffffff;
      cursor: pointer;
      height: 24px;
    }
  }
  &.my-collection-area-mobile {
    .el-scrollbar {
      height: 100%;
      .el-scrollbar__bar {
        display: none;
      }
    }
    .book-list {
      padding-top: 16px;
      .common-list-wrapper {
        .common-list {
          height: 100%;
          padding-top: 0;
        }
      }
      &.collect {
        .common-list-wrapper {
          height: calc(100vh - 180px);
        }
      }
      &.orderRec {
        .common-list-wrapper {
          height: calc(100vh - 90px);
        }
      }
      &.order {
        .common-list-wrapper {
          height: calc(100vh - 140px);
        }
      }
    }
  }
}
</style>
